import { Box, Grid, IconButton, Link, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { BCPArrowLeft } from "../../../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";

export function HeaderBackButton() {
  return (
    <Box sx={{ position: "absolute", left: "15px" }}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="back"
        sx={{ position: "relative", top: "15px" }}
        onClick={() => window.history.back()}
      >
        <BCPArrowLeft />
      </IconButton>
    </Box>
  );
}
export default function GroupHeader({ label, embed, back }) {
  const theme = useTheme();

  return (
    <>
      {back && <HeaderBackButton />}
      <Grid container alignItems="center">
        <Grid item xs={12} textAlign="center">
          <Box>
            <Box>
              <Typography variant="caption" gutterBottom>
                Powered by
              </Typography>
            </Box>
            <Box>
              <Link
                target="_blank"
                href={`${window.location.protocol}//${window.location.host}`}
                underline="none"
              >
                <img
                  src={`${getEnvironmentVariable(
                    "SYSTEM_IMAGES_CLOUDFRONT"
                  )}/images/BannerLogo${
                    theme?.palette?.mode === "dark" ? "Dark" : ""
                  }Large.png`}
                  alt="logo"
                  style={{
                    maxHeight: "45px",
                    marginRight: "8px",
                  }}
                />
              </Link>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
